const TEST_SERIES_CONSTANTS = {
  NOT_ANSWERED: -1,
  MARKED_FOR_REVIEW: -4,
};

export default TEST_SERIES_CONSTANTS;
